// import React from 'react';

// const HeroSection = () => {
//   return (
//     <section className="min-h-screen px-4 py-12 bg-gradient-to-br from-[#18002c] via-[#1a0033] to-[#220043] text-white font-sans">
//       {/* Nav */}
//       <nav className="flex justify-between items-center max-w-6xl mx-auto py-4 px-2 backdrop-blur-sm rounded-full border border-pink-500/30 bg-white/5">
//         <h1 className="text-lg font-semibold tracking-wide text-white">
//           <span className="text-fuchsia-400">●</span> Systematic <span className="font-light">Career Planner</span>
//         </h1>
//         <ul className="flex space-x-6 text-sm font-medium">
//           <li><a href="#" className="hover:text-fuchsia-400">Home</a></li>
//           <li><a href="#" className="hover:text-fuchsia-400">Assessments</a></li>
//           <li><a href="#" className="hover:text-fuchsia-400">Roadmap</a></li>
//           <li><a href="#" className="hover:text-fuchsia-400">Skills</a></li>
//         </ul>
//         <button className="w-8 h-8 rounded-full border border-fuchsia-400 text-fuchsia-300 text-xl flex items-center justify-center hover:bg-fuchsia-600/20">+</button>
//       </nav>

//       {/* Hero */}
//       <div className="text-center mt-20 max-w-3xl mx-auto">
//         <h2 className="text-4xl md:text-5xl font-extrabold leading-tight text-white">
//           Plan Your <span className="text-pink-400">Future Career</span><br />
//           Path with <span className="text-pink-400">Confidence</span>
//         </h2>
//         <p className="text-gray-300 mt-4 text-lg">Explore, set goals, and develop skills for a successful future.</p>
//         <button className="mt-8 px-6 py-3 bg-pink-500 hover:bg-pink-600 transition-all rounded-full text-white font-medium shadow-lg shadow-pink-500/20">
//           Get Started
//         </button>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;
// src/components/Hero.jsx
// src/components/Hero.jsx
import React from "react";
import BlobBackground from "../backgrounds/BlobBackground";

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
          {/* Animated gradient background */}
          <div className="absolute inset-0 bg-gradient-to-r from-pink-300 via-yellow-200 to-sky-300 animate-gradient-x " />
          <div></div>
          <div className="absolute inset-0 opacity-20">
                   <BlobBackground />
          </div>
          
          {/* Floating fun shapes */}
          <div className="absolute top-20 left-10 text-5xl animate-bounce">🎓</div>
          <div className="absolute top-1/3 right-20 text-4xl animate-floaty">📚</div>
          <div className="absolute bottom-20 left-1/4 text-6xl animate-spin-slow">⭐</div>
    
          <div className="my-10 relative z-10 mx-auto max-w-6xl px-6 pt-24 pb-32 text-center">
            <h1 className="font-heading text-4xl md:text-6xl font-extrabold drop-shadow-lg">
              Plan Your <span className="text-indigo-700">Career</span> Like You <br /> Plan Your <span className="text-pink-600">Investments</span>
            </h1>
            <p className="mt-6 max-w-2xl mx-auto text-lg md:text-xl font-sans text-gray-700">
              Guided decisions at every stage — from crucial points of education to career growth. Invest time. Build career. Secure future.
            </p>
        <div className="mt-4 flex flex-wrap justify-center gap-3 text-sm font-semibold text-gray-600">
          <span className="bg-white/80 px-4 py-1.5 rounded-full shadow">8th Std</span>
          <span className="bg-white/80 px-4 py-1.5 rounded-full shadow">10th Std</span>
          <span className="bg-white/80 px-4 py-1.5 rounded-full shadow">12th Std</span>
          <span className="bg-white/80 px-4 py-1.5 rounded-full shadow">Career Switch</span>
        </div>
        <div className="mt-8 flex justify-center gap-4">
          <a
            href="#contact"
            className="rounded-full bg-indigo-600 text-white px-6 py-3 text-lg shadow-lg hover:scale-110 hover:shadow-xl transition"
          >
            📅 Book Free Consultation
          </a>
          <a
            href="#services"
            className="rounded-full border-2 border-indigo-500 bg-white/70 px-6 py-3 text-lg hover:bg-indigo-50 hover:scale-105 transition"
          >
            🚀 Explore Career Paths
          </a>
        </div>
      </div>
    </section>
  );
}
